import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface TranscriptionRequest {
  audio: Blob;
  duration: number;
  sessionId: string;
  timestamp: string;
}

export interface TranscriptionResponse {
  success: boolean;
  text?: string;
  error?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ChatTranscribeService {
  private readonly http = inject(HttpClient);

  /**
   * Sends audio for transcription to the speech-to-text service
   */
  transcribeAudio(request: TranscriptionRequest): Observable<TranscriptionResponse> {
    const formData = new FormData();
    formData.append('audio', request.audio, 'voice-message.wav');
    formData.append('duration', request.duration.toString());
    formData.append('sessionId', request.sessionId);
    formData.append('timestamp', request.timestamp);

    // Send to speech-to-text service
    const endpoint = 'https://speech-to-text.tabit-int.com/transcribe';

    return this.http.post<TranscriptionResponse>(endpoint, formData);
  }


}
